"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IMGElementContentSuccess;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultImageStyle = {
  resizeMode: 'cover'
};
/**
 * Default success "image" view for the {@link IMGElement} component.
 */

function IMGElementContentSuccess({
  source,
  imageStyle,
  dimensions,
  onError
}) {
  const onImageError = (0, _react.useCallback)(({
    nativeEvent: {
      error
    }
  }) => onError(error), [onError]);
  return /*#__PURE__*/_react.default.createElement(_reactNative.Image, {
    source: source,
    onError: onImageError,
    style: [defaultImageStyle, dimensions, imageStyle],
    testID: "image-success"
  });
}
//# sourceMappingURL=IMGElementContentSuccess.js.map